import template from './template.html'

export default {
  bindings: {
    tags: '<'
  },
  template
}
